<div class="px-4" [class]="direction">
  <h3 class="text-lg">{{ lastSearchesText }}</h3>

  @if (
    !!favoriteLines?.lastSearches && !!favoriteLines?.lastSearches.length) {
    <ul class="flex flex-col list-none p-0 gap-2">
      @for (lineData of favoriteLines.lastSearches; track lineData) {
        <li
          class="cursor-pointer"
          role="button"
          tabindex="0"
          [attr.aria-label]="lineRowAriaLabel(lineData)"
          (click)="onFavoriteLineClick.emit(lineData)"
          (keydown.enter)="onFavoriteLineClick.emit(lineData)"
          (keydown.space)="$event.preventDefault(); onFavoriteLineClick.emit(lineData)"
          >
          <app-favorite-line [line]="lineData" />
        </li>
        <mat-divider class="bg-gray-600" />
      }
    </ul>
  } @else {
    <img src="/assets/images/route-planning/search-line/last_lines_empty.svg" alt="" aria-hidden="true" />
  }

</div>

<div class="px-4">
  <div class="flex justify-between items-center" [class]="direction">
    <h3 class="text-lg">{{ favoriteLinesText }}</h3>
    <mot-button
      (onClick)="openEditFavoritesMenu()"
      textClass="text-base"
      buttonClass="!bg-transparent"
      [text]="editText"
      ariaHaspopup="dialog"
      />
    </div>

    @if (
      !!favoriteLines?.routes && !!favoriteLines?.routes.length) {
      <ul class="flex flex-col list-none p-0 gap-2" [class]="direction">
        @for (lineData of favoriteLines?.routes; track lineData) {
          <li
            class="cursor-pointer"
            role="button"
            tabindex="0"
            [attr.aria-label]="lineRowAriaLabel(lineData)"
            (click)="onFavoriteLineClick.emit(lineData)"
            (keydown.enter)="onFavoriteLineClick.emit(lineData)"
            (keydown.space)="$event.preventDefault(); onFavoriteLineClick.emit(lineData)"
            >
            <!-- Pick handled by <li> click (bubbles from line-details) + keyboard; avoid double emit with onPickFavoriteClick -->
            <app-favorite-line [line]="lineData" />
          </li>
          <mat-divider class="bg-gray-600" />
        }
      </ul>
    } @else {
      <div class="flex gap-2 items-center" [class]="direction" aria-hidden="true">
        <img
          src="assets/images/route-planning/search-line/line_empty_state.svg"
          alt=""
          />
        <div class="flex flex-col gap-[0.125rem]">
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteLinesTextPart1 }}</span>
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteLinesTextPart2 }}</span>
        </div>
      </div>
    }


    </div>
